<template>
  <section class="undermain">
    <div class="undermain__title">
      Забронируйте авто по телефону и получите
      дополнительную выгоду <span>30 000 руб.</span><sup>*</sup>
    </div>
    <callback-form class="undermain__form">Получить предложение</callback-form>
  </section>
</template>


<script>
import CallbackForm from './callback-form';

export default {
  components: { CallbackForm },
}
</script>


<style lang="scss" scoped>

.undermain {
  padding: 0 15px;
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  &__title {
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 10px;
    span {
      white-space: nowrap;
      color: #e2231b;
      font-size: 1.2em;
    }
  }
  &__form {
    align-self: center;
  }
}

</style>